import React, { useState, useEffect } from "react";
import API from "../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import "../News/News.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Faqpreview from "../FAQ/FAQPreview";
import CharIcon from "../../Assets/img/word.png";
const FAQAdd = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    language_id: "",
    category_id: "",
    question: "",
    answers: "",
    createdBy: 1,
    updatedBy: 1,
  });
  const [lastValidAnswer, setLastValidAnswer] = useState("");

  const [categories, setCategories] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [immigrationType, setImmigrationType] = useState([]);
  const [consultationType, setConsultationType] = useState([]);
  const [immigration, setImmigration] = useState("");

  const [languageId, setLanguageId] = useState(1);

  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: "",
    type: "info",
  });


  const fetchCategories = (langId) => {
    API.post("faqsCategory_list/condition", { language_id: langId })
      .then((res) => {
        const categoryData = res?.data?.data?.data || [];
        const activeCategories = categoryData.filter(
          (item) => item.status === "active"
        );
        setCategories(activeCategories);
      })
      .catch(() => {
        setPopup({
          show: true,
          title: "Error",
          message: "Failed to load categories.",
          type: "failed",
        });
      });
  };



  useEffect(() => {
    if (formData.language_id) {
      fetchCategories(formData.language_id);
    }
  }, [formData.language_id]);

  const fetchimmigration = (langId = languageId) => {
    API.post("listofservicelist/condition", { language_id: langId })
      .then((res) => {
        const immigrationData = (res?.data?.data?.data || [])
          .slice()
          .sort((a, b) => Number(a.order_by) - Number(b.order_by));
        setImmigrationType(immigrationData);
      })
      .catch((err) => console.error("Failed to fetch immigration types:", err));
  };


  // const fetchconsultation = (langId = languageId) => {
  //   API.post("consultationtypelist/condition", { language_id: langId })
  //     .then((res) => {
  //       const consultationData = res?.data?.data || [];
  //       setConsultationType(consultationData);
  //     })
  //     .catch((err) => console.error("Failed to fetch consultation types:", err));
  // };
  useEffect(() => {
    fetchimmigration(languageId);
    // fetchconsultation(languageId);
  }, [languageId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "language_id") {
      setFormData({ ...formData, language_id: value, category_id: "" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const handleSubmit = () => {
    if (!formData.language_id || !formData.category_id || !formData.question || !formData.answers) {
      setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all required fields.",
        type: "info",
      });
      return;
    }

    API.post("faqsQuestion_answer/add", formData)
      .then(() => {
        setPopup({
          show: true,
          title: "Success",
          message: "FAQ added successfully!",
          type: "success",
        });
        // setTimeout(() => navigate("/faq"), 3500);
      })
      .catch(() => {
        setPopup({
          show: true,
          title: "Error",
          message: "Failed to add FAQ.",
          type: "failed",
        });
      });
  };

  const handlePreview = () => {
    if (!formData.category_id || !formData.question || !formData.answers) {
      setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all fields to preview.",
        type: "info",
      });
      return;
    }
    setPreviewData({ ...formData, category_id: "preview" });
    setShowPreview(true);
  };
  const getPlainTextLength = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent?.length || 0;
  };
  return (
    <div className="news-container">
      <div className="newsadd-container">
        {/* Header */}
        <div className="newsadd-header">
          <h2 className="newsadd-title">Add FAQ</h2>
          <div className="header-buttons">
            <button onClick={handlePreview} className="btn saves-btn">Preview</button>
            <button onClick={handleSubmit} className="btn saves-btn">Save</button>
            <button onClick={() => navigate("/faq")} className="cancel-btn ">Back</button>
          </div>
        </div>

        {/* Form */}
        <div className="newsadd-formcard" >
          <div className="news-form-group" style={{ flexDirection: "unset" }}>

            <div style={{ flex: 1 }}>
              <label>Language <span className="required">*</span></label>
              <div style={{ marginTop: "11px" }}>
                <select
                  name="language_id"
                  value={formData.language_id}
                  onChange={handleChange}
                >
                  <option value="">Select Language</option>
                  <option value="1">English</option>
                  <option value="2">Français</option>
                </select>
              </div>
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>
                Category <span className="required">*</span>
              </label>
              <select
                name="category_id"
                value={immigration}
                onChange={(e) => {
                  const value = e.target.value;
                  setImmigration(value);
                  setFormData((prev) => ({ ...prev, category_id: value }));
                }}
                className="input-field"
                style={{ width: "100%" }}
              >
                <option value="">Select Category</option>
                {immigrationType.map((cat) => (
                  <option
                    key={cat.listofservice_id}
                    value={cat.listofservice_id}
                  >
                    {cat.heading}
                  </option>
                ))}
              </select>
            </div>

          </div>
          <div className="form-group">
            <label className="description-label">
              <span className="label-text">
                Question <span className="required">*</span>
              </span>
              <div className="char-wrapper">
                <img src={CharIcon} alt="Character count" />
                <span className="char-count">
                  {getPlainTextLength(formData.question)}/100
                </span>
              </div>
            </label>
            <input
              type="text"
              name="question"
              placeholder="Enter question"
              value={formData.question}
              onChange={(e) => {
                if (e.target.value.length <= 100) {
                  setFormData({ ...formData, question: e.target.value });
                }
              }}
            />
          </div>

          <div className="form-group">
            <label className="description-label">
              <span className="label-text">
                Answer <span className="required">*</span>
              </span>
              <div className="char-wrapper">
                <img src={CharIcon} alt="Character count" />
                <span className="char-count">
                  {getPlainTextLength(formData.answers)}/4000
                </span>
              </div>
            </label>

            <CKEditor
              editor={ClassicEditor}
              data={formData.answers}
              onChange={(event, editor) => {
                const html = editor.getData();
                const div = document.createElement("div");
                div.innerHTML = html;
                const textLength = div.textContent?.length || 0;

                if (textLength <= 4000) {
                  setLastValidAnswer(html);
                  setFormData(prev => ({ ...prev, answers: html }));
                } else {
                  editor.setData(lastValidAnswer);
                }
              }}
              config={{
                toolbar: [
                  "undo", "redo", "|",
                  "heading", "|",
                  "bold", "italic", "underline", "|",
                  "bulletedList", "numberedList",
                ],
              }}
              className="description1-editor"
            />

          </div>
        </div>
      </div>

      {/*  Preview Popup */}
      {showPreview && (
        <div className="preview-overlay" onClick={() => setShowPreview(false)}>
          <div
            className="preview-modal-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={() => setShowPreview(false)}>
              ✕
            </button>
            <Faqpreview previewNews={previewData} />
          </div>
        </div>
      )}

      {/* Popup Message */}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <div className="popup-buttons">
              <button
                className="btn ok-btn"
                onClick={() => {
                  setPopup({ ...popup, show: false });

                  if (popup.type === "success") {
                    navigate("/faq");
                  }
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default FAQAdd;
